import { BusinessEntitiesRoot, ScreenRoot } from "types";

export const BusinessEntitiesRootDefinition: ScreenRoot = {
  name: BusinessEntitiesRoot,
  routePath: ["/business-entities/*"],
  accessPath: "businessEntities",
};
